import { createAction } from 'redux-actions';
import { TOGGLE_POSITION_OVERLAY, TOGGLE_MOBILE_HEADER_SEARCH } from './const';

const togglePositionOverlay = createAction(TOGGLE_POSITION_OVERLAY.ACTION);
const toggleMobileHeaderSearch = createAction(TOGGLE_MOBILE_HEADER_SEARCH.ACTION);

export { togglePositionOverlay, toggleMobileHeaderSearch };
